/* Optional discoveries only: no storage, tracking, forms or shopping API calls. */
(() => {
  if (window.__bkBureauEggsInstalled) return;
  window.__bkBureauEggsInstalled = true;
  const openings = new WeakMap();
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const summary = event.target.closest('[data-bk-egg="twig"] > summary');
    const egg = summary?.parentElement;
    if (egg?.open && !egg.hasAttribute('data-repeat')) {
      event.preventDefault();
      egg.setAttribute('data-repeat', '');
    }
  });
  document.addEventListener('toggle', event => {
    const egg = event.target;
    if (!(egg instanceof HTMLDetailsElement) || !egg.matches('[data-bk-egg]') || !egg.open) return;
    const count = (openings.get(egg) || 0) + 1;
    openings.set(egg, count);
    if (count > 1) egg.setAttribute('data-repeat', '');
    const note = egg.querySelector(':scope > .bk-egg-note');
    if (note && note.getBoundingClientRect().bottom > window.innerHeight - 96) {
      note.scrollIntoView({block: 'center', behavior: 'instant'});
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const inner = event.target.closest('.bk-bo details[open], .bk-bo[open]');
    if (inner) { inner.open = false; inner.querySelector(':scope > summary')?.focus({preventScroll:true}); event.preventDefault(); return; }
    const egg = event.target.closest('[data-bk-egg][open]');
    if (!egg) return;
    egg.open = false;
    egg.querySelector(':scope > summary')?.focus({preventScroll: true});
    event.preventDefault();
  });
})();
/* A fictional, session-only office. No requests, inputs, persistence or sound. */
(() => {
 if (window.__bkBackOfficeInstalled) return;
 window.__bkBackOfficeInstalled = true;
 const states = new WeakMap();
 const lines = (office, selector) => [...office.querySelector(selector).children].map(el => el.textContent);
 const animate = (el, cls) => { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };
 function enhance(office) {
  if (states.has(office)) return;
  states.set(office, {rings:0, duck:0, compliment:null});
  office.querySelectorAll('[data-bo-enhanced]').forEach(el => {el.hidden = false;});
  office.querySelector('.bk-bo-nojs').hidden = true;
  for (const el of office.querySelectorAll('[role="status"]')) el.dataset.boInitial = el.textContent;
 }
 const start = () => document.querySelectorAll('[data-bk-backoffice]').forEach(enhance);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
 document.addEventListener('shopify:section:load', start);
 document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('button[data-bo-action]');
  const office = button?.closest('[data-bk-backoffice]');
  if (!office || button.disabled) return;
  enhance(office); const state = states.get(office);
  const output = selector => office.querySelector(selector);
  switch (button.dataset.boAction) {
   case 'bell': {
    state.rings += 1;const replies = lines(office,'[data-bo-bell-lines]');
    output('[data-bo-bell-response]').textContent = replies[(state.rings - 1) % replies.length];
    output('[data-bo-count]').textContent = String(state.rings);
    output('[data-bo-secret]').hidden = state.rings < 5;
    animate(button,'bk-bo-hit'); break;
   }
   case 'compliment': {
    state.compliment = Number(button.dataset.boIndex);
    office.querySelectorAll('[data-bo-action="compliment"]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
    output('[data-bo-action="file"]').disabled = false;break;
   }
   case 'file': {
    if (state.compliment === null) return;
    output('[data-bo-receipt]').textContent = lines(office,'[data-bo-receipts]')[state.compliment];
    animate(output('[data-bo-receipt]'),'bk-bo-filed');break;
   }
   case 'duck': {
    const replies = lines(office,'[data-bo-duck-lines]');
    output('[data-bo-duck-response]').textContent = replies[state.duck++ % replies.length];
    animate(output('[data-bo-duck-response]'),'bk-bo-filed');break;
   }
   case 'permit': {
    const index = Number(output('[data-bo-permit]').value);
    output('[data-bo-permit-response]').textContent = lines(office,'[data-bo-permit-lines]')[index];
    animate(output('[data-bo-permit-response]'),'bk-bo-filed');break;
   }
   case 'lamp': {
    const off = button.getAttribute('aria-checked') === 'true';
    button.setAttribute('aria-checked',String(!off));
    output('[data-bo-lights]').dataset.boLights = off ? 'off' : 'on';
    output('[data-bo-lamp-response]').textContent = lines(office,'[data-bo-lamp-lines]')[off ? 1 : 0];break;
   }
   case 'reset': {
    state.rings = 0;state.duck = 0;state.compliment = null;
    output('[data-bo-count]').textContent = '0';output('[data-bo-secret]').hidden = true;
    office.querySelectorAll('[data-bo-action="compliment"]').forEach(el=>el.setAttribute('aria-pressed','false'));
    output('[data-bo-action="file"]').disabled = true;output('[data-bo-permit]').value = '0';
    output('[data-bo-action="lamp"]').setAttribute('aria-checked','true');output('[data-bo-lights]').dataset.boLights = 'on';
    office.querySelectorAll('[role="status"]').forEach(el=>{el.textContent=el.dataset.boInitial;el.classList.remove('bk-bo-filed');});
    office.querySelectorAll('details[open]').forEach(el=>{el.open=false;});break;
   }
  }
 });
})();
/* Decorative office responses; original controls and session-only state remain authoritative. */
(() => {
 if (window.__bkBureauVisualsInstalled) return;
 window.__bkBureauVisualsInstalled = true;
 const sceneFor = office => office.querySelector('[data-bo-leave-scene]');
 document.addEventListener('change', event => {
  if (!(event.target instanceof Element) || !event.target.matches('[data-bo-permit]')) return;
  const scene = sceneFor(event.target.closest('[data-bk-backoffice]'));
  if (scene) scene.dataset.boLeaveScene = event.target.value;
 });
 document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('button[data-bo-action]');
  const office = button?.closest('[data-bk-backoffice]');
  if (!office || button.disabled) return;
  if (button.dataset.boAction === 'reset') {
   const scene = sceneFor(office); if (scene) scene.dataset.boLeaveScene = '0';
  }
  const selector = button.dataset.boAction === 'bell' ? '.bk-bo-reception-scene' : button.dataset.boAction === 'lamp' ? '.bk-bo-night-scene' : null;
  const scene = selector && office.querySelector(selector);
  if (scene) { scene.classList.remove('bk-bo-visual-react'); void scene.offsetWidth; scene.classList.add('bk-bo-visual-react'); }
 });
})();
